import { Alert, Card, Col, Empty, Input, Row, Spin } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";

import { PageHeader } from "../../ui";
import { useManualIndex } from "./manualHooks";
import "./manual.css";

export function ManualHome() {
  const index = useManualIndex();
  const [search, setSearch] = useState("");
  const needle = search.trim().toLocaleLowerCase();
  return (
    <div className="manual-home">
      <PageHeader title="マニュアル" description="操作の手順をアプリごとに確認できます。" />
      <Input.Search aria-label="見出しを検索" placeholder="見出しを検索" value={search}
        onChange={(e) => setSearch(e.target.value)} allowClear />
      {index.isPending && <Spin />}
      {index.isError && <Alert type="error" showIcon message="マニュアルを取得できませんでした" />}
      {index.data?.modules.length === 0 && <Empty description="マニュアルが同梱されていない" />}
      <Row gutter={[16, 16]}>
        {index.data?.modules.filter((m) => !needle || m.sections.some((s) =>
          s.title.toLocaleLowerCase().includes(needle))).map((m) => (
          <Col key={m.module} xs={24} lg={12}>
            <Card title={<Link to={`/manual/${m.module}`}>{m.label}</Link>}
              extra={`${m.sections.length} 節`}>
              <ul>
                {(needle ? m.sections.filter((s) => s.title.toLocaleLowerCase().includes(needle))
                  : m.sections.filter((s) => s.level === 2).slice(0, 5)).map((s) => (
                  <li key={s.id}><Link to={`/manual/${m.module}#${encodeURIComponent(s.anchor)}`}>{s.title}</Link></li>
                ))}
              </ul>
            </Card>
          </Col>
        ))}
      </Row>
      {needle && index.data && !index.data.modules.some((m) => m.sections.some((s) =>
        s.title.toLocaleLowerCase().includes(needle))) && <Empty description="一致する見出しがありません" />}
    </div>
  );
}
